import { render, staticRenderFns } from "./Dentists.html?vue&type=template&id=5b24f1a7&external"
import script from "./Dentists.js?vue&type=script&lang=js&external"
export * from "./Dentists.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports